(function() {
    window.apos = window.apos || {};
    var data = document.body && document.body.getAttribute('data-apos');
    Object.assign(window.apos, JSON.parse(data || '{}'));
    if (data) {
      document.body.removeAttribute('data-apos');
    }
    if (window.apos.modules) {
      for (const module of Object.values(window.apos.modules)) {
        if (module.alias) {
          window.apos[module.alias] = module;
        }
      }
    }
})();
import 'vite/modulepreload-polyfill';
import "./@apostrophecms/styles/src/index.scss";
import "./@apostrophecms/ui/src/index.scss";
import "./@apostrophecms/image-widget/src/index.scss";
import "./asset/src/index.scss";
import "./theme/src/index.scss";
import "./@local/newsletter/src/index.scss";
import "./@local/diary-page/src/index.scss";
import index_0App from "./@apostrophecms/util/src/index.js";
import index_1App from "./@apostrophecms/i18n/src/index.js";
import index_2App from "./@apostrophecms/template/src/index.js";
import index_3App from "./@apostrophecms/admin-bar/src/index.js";
import index_4App from "./@apostrophecms/video-widget/src/index.js";
import index_5App from "./@apostrophecms/blog-page/src/index.js";
import index_6App from "./asset/src/index.js";
import index_7App from "./@local/newsletter/src/index.js";
import index_8App from "./@local/gallery-widget/src/index.js";
index_0App();
index_1App();
index_2App();
index_3App();
index_4App();
index_5App();
index_6App();
index_7App();
index_8App();
